import { useEffect, useState } from "react";

import { type MylensesInsightsSections } from "@snapchat/blizzard-schema";

import { useBlizzardEvents } from "../../analytics/hooks";

import { useLensIdSearchParameter } from "./useLensIdSearchParameter";

export const useInsightsPageBlizzardEvent = (section: MylensesInsightsSections): void => {
    const [viewedOnce, setViewedOnce] = useState(false);

    const { sendBlizzardEvent } = useBlizzardEvents();
    const { lensId } = useLensIdSearchParameter();

    useEffect(() => {
        if (!viewedOnce) {
            sendBlizzardEvent({
                event: "MYLENSES_INSIGHTS_PAGE_VIEW",
                section,
                lensId: lensId ?? "",
            });
            setViewedOnce(true);
        }
    }, [sendBlizzardEvent, section, lensId, setViewedOnce, viewedOnce]);
};
